import parseBarcodeNumber from "./parseBarcodeNumber"

export default (barcode1, barcode2) => {
    if (!barcode1 || !barcode2) return false

    const parsed1 = parseBarcodeNumber(barcode1)
    const parsed2 = parseBarcodeNumber(barcode2)

    if (!parsed1 || !parsed2) return false

    return parsed1.number === parsed2.number
}

